'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('ng-sortable');

require('v-accordion/dist/v-accordion.min.css');

require('v-accordion/dist/v-accordion.min.js');

require('../../../../feiseanna');

require('../../../../../event-info');

require('../../../../../events');

require('../../../../../prompt');

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _util = require('../../../../../util');

var _stages = require('ifeis-isomorphic/lib/redux/actions/stages');

var _mapStateToStageSchedule = require('./../../../../../util/mapStateToStageSchedule');

var _mapStateToStageSchedule2 = _interopRequireDefault(_mapStateToStageSchedule);

var _classesForEvent = require('../../../../../common/utils/classes-for-event');

require('./styles.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FeisDashboardController = function () {
  function FeisDashboardController(feis, $scope, msgService, $mdDialog, fEventEditor, fEventInfoDialog, $rootScope, $ngRedux, $q, $state, fEventService, metadata, isGod) {
    var _this = this;

    _classCallCheck(this, FeisDashboardController);

    // for dynamic breadcrumbs
    $scope.hasAnyGrantsForFeis = isGod || metadata.grants.length;

    this.feis = feis;
    this.hasManageGrants = isGod || metadata.grants.indexOf('chair') > -1 || metadata.grants.indexOf('tabulations') > -1;
    this.classesForEvent = _classesForEvent.classesForEvent;
    this.registeredAndSaved = { registered: metadata.registered == 1 && true || false, saved: metadata.saved == 1 && true || false };

    this._ = {
      msgService: msgService,
      $mdDialog: $mdDialog,
      $q: $q,
      fEventEditor: fEventEditor,
      fEventInfoDialog: fEventInfoDialog,
      $state: $state,
      $rootScope: $rootScope,
      $scope: $scope,
      $ngRedux: $ngRedux
    };

    this.statuses = fEventService.statuses;
    this.days = (0, _util.getFeisDays)(this.feis);
    var currentDayIdx = this.days.findIndex(function (day) {
      return day.date === (0, _moment2.default)().tz(_this.feis.tz).startOf('day').valueOf();
    }) || 0;
    this.selectedDayIdx = currentDayIdx > 0 && currentDayIdx || 0;

    $ngRedux.dispatch((0, _stages.getSchedule)(feis.id));
    $ngRedux.connect((0, _mapStateToStageSchedule2.default)(feis.id))(this);

    this._.$ngRedux.dispatch({ type: '/SOCKET_JOIN_ROOM', data: { room: 'EVENTS::' + this.feis.id, feisId: this.feis.id } });
    this._.$ngRedux.dispatch({ type: '/SOCKET_JOIN_ROOM', data: { room: 'SCHEDULE::' + this.feis.id, feisId: this.feis.id } });

    this._.$scope.$on('$destroy', function () {
      return _this._.$ngRedux.dispatch({ type: '/SOCKET_LEAVE_ROOM', data: { room: 'EVENTS::' + _this.feis.id, feisId: _this.feis.id } });
    });
    this._.$scope.$on('$destroy', function () {
      return _this._.$ngRedux.dispatch({ type: '/SOCKET_LEAVE_ROOM', data: { room: 'SCHEDULE::' + _this.feis.id, feisId: _this.feis.id } });
    });
  }

  _createClass(FeisDashboardController, [{
    key: 'showEvent',
    value: function showEvent($event, event) {
      if (event.placeholder === 1) {
        return;
      }

      return this._.fEventInfoDialog(this.feis, event, this.hasManageGrants, this.registeredAndSaved);
    }
  }, {
    key: 'goBack',
    value: function goBack(e) {
      e.preventDefault();
      e.stopPropagation();

      var previousState = this._.$rootScope.previousState ? this._.$rootScope.previousState : '^';
      this._.$state.go(previousState);
    }
  }]);

  return FeisDashboardController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.dashboard', ['ui.router', 'ngMaterial', 'ngAnimate', _ngRedux2.default, 'vAccordion', 'ifeis.feiseanna', 'ifeis.event-info', 'ifeis.stages.service', 'ifeis.stages.actions', 'ifeis.stages.store', 'ifeis.events', 'ifeis.prompt', 'ifeis.syllabi.editor']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.dashboard', {
    url: '/dashboard',
    template: require('./tpl.html'),
    controller: 'FeisDashboardController',
    controllerAs: 'dashboard',
    ncyBreadcrumb: {
      label: 'Status Dashboard',
      parent: function parent($scope) {
        return $scope.hasAnyGrantsForFeis ? 'feiseanna.one.admin.manager' : 'feiseanna.one.landing-page';
      }
    }
  });
}).controller('FeisDashboardController', FeisDashboardController);


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/dashboard/index.js
// module id = 542
// module chunks = 0